import React from 'react';
import styles from './Stars.scss';
export const GenericStars = _ref => {
  let {
    Icon,
    gap
  } = _ref;
  return _ref2 => {
    let {
      rating,
      a11yLabel,
      className = '',
      dataHook,
      collapsed
    } = _ref2;
    const normalizedRating = Math.min(Math.max(rating, 0), 5);
    return /*#__PURE__*/React.createElement("div", {
      className: [styles.root, gap === 'small' ? styles.smallGap : styles.largeGap, className].join(' '),
      "data-hook": dataHook,
      "data-value": normalizedRating
    }, a11yLabel && /*#__PURE__*/React.createElement("span", {
      className: styles.a11yLabel
    }, a11yLabel), /*#__PURE__*/React.createElement("div", {
      "aria-hidden": "true",
      className: styles.innerContainer
    }, (collapsed ? [1] : [1, 2, 3, 4, 5]).map(index => {
      const iconState = toStarState(normalizedRating, index);
      switch (iconState) {
        case 'full':
          return /*#__PURE__*/React.createElement(Icon, {
            key: index,
            className: styles.full
          });
        case 'empty':
          return /*#__PURE__*/React.createElement(Icon, {
            key: index,
            className: styles.empty
          });
        case 'half':
          return /*#__PURE__*/React.createElement("div", {
            className: styles.halfStarWrapper,
            key: index
          }, /*#__PURE__*/React.createElement(Icon, {
            key: "start",
            className: [styles.halfStarInnerWrapperStart, styles.full].join(' ')
          }), /*#__PURE__*/React.createElement(Icon, {
            key: "end",
            className: [styles.halfStarInnerWrapperEnd, styles.empty].join(' ')
          }));
        default:
          throw unreachable(iconState);
      }
    })));
  };
};

/* index is 1 to 5, like rating */
function toStarState(rating, index) {
  if (index <= rating) {
    return 'full';
  }
  if (index - rating < 1) {
    const partial = index - rating;
    return partial < 0.25 ? 'full' : partial > 0.75 ? 'empty' : 'half';
  }
  return 'empty';
}
export function unreachable(param) {
  return new Error("Unreachable case with value " + JSON.stringify(param));
}
//# sourceMappingURL=GenericStars.js.map